import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { goBack } from 'react-router-redux';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { createHashHistory } from 'history';
import ClearOutlinedIcon  from '@material-ui/icons/ClearOutlined';

const hashHistory = createHashHistory();

const style = {
  fontFamily:"Open Sans Hebrew", 
  color:"#000000",
  alignItems: "flex-start",
  justifyContent: "flex-start"
}

class BackButton extends Component {
    handleClick = () => {
        hashHistory.goBack();
    };
    render() {
        return (
            <Button style={style} color="primary" onClick={this.handleClick}>
                <ClearOutlinedIcon fontSize="small"></ClearOutlinedIcon>
            </Button>);
    }
}

export default connect(null, {goBack})(BackButton);